import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/auth";
import InviteCodeModal from "../Modals/inviteCodeModal/InviteCodeModal";
import JoinEvent from "../pages/joinEvent/JoinEvent";
import axios from "axios";
import Sidebar from "./sidebar/Sidebar";
import { Alert } from "@mui/material";

const InviteLinkHandler = () => {
  const { hostId: id, code: urlCode } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  const isUsherPath = location.pathname.includes("/join-Usher");
  const role = isUsherPath ? "usher" : "guest";

  const [verificationError, setVerificationError] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  const defaultCode =
    urlCode && urlCode.length >= 6 ? urlCode.slice(0, 6).toUpperCase() : "";

  if (isLoading) {
    return <div className="loading-fullscreen">Loading...</div>;
  }

  const handleProceed = async (inputCode) => {
    const code = inputCode.trim().toUpperCase();

    if (!code || code.length !== 6) {
      setVerificationError("Please enter a valid 6-digit code");
      return;
    }

    setIsVerifying(true);
    setVerificationError("");

    try {
      const res = await axios.get(`/invite/${id}`, {
        params: {
          code,
          role,
          userId: null,
        },
      });

      const data = res.data;

      const isSuccess =
        data.success === true ||
        data.successStatus === true ||
        data.message?.toLowerCase().includes("verified");

      if (!isSuccess) {
        alert(data.message || "Invalid or expired invite code");
        return;
      }

      navigate("/login", {
        state: {
          fromInviteLink: true,
          role,
          inviteCode: code,
          hostId: id,
        },
        replace: true,
      });
    } catch (err) {
      setVerificationError(err.message || "Failed to verify code");
    } finally {
      setIsVerifying(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="login-container">
        <div className="login-img-container">
          <img
            src="/images/onboarding-page-image.webp"
            alt="NimbleBash celebration"
            className="login-celebration-img"
          />
        </div>
        <InviteCodeModal
          isOpen={true}
          onClose={() => navigate("/")}
          onProceed={handleProceed}
          defaultCode={defaultCode}
          isLoading={isVerifying}
          error={verificationError}
          message={`You're joining as ${
            role === "usher" ? "an Usher" : "a Guest"
          }!`}
          editable={true}
        />
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <div className="nav-container">
        <div className="desktop-sidebar">
          <Sidebar />
        </div>
        <div className="main-home-content">
          <JoinEvent role={role} />
        </div>
      </div>
    );
  }

};

export default InviteLinkHandler;
